import React from "react"
import HighConvertingSequencesImage from "../../../../../components/staticQuery/platform/automation/HighConvertingSequencesImage"
import P from "../../../../../components/typography/P"

import BuildGraphic from "../../../../../images/platform/build-campaign.svg"

const DescriptionText = () => (
  <>
    <P>
      Create powerful and intelligent Automation Sequences with Conditional
      Starts and Stops, Email and Text Communication, Actions, Delays and
      Branching.
    </P>
  </>
)

const highConvertingSequencesData = {
  titleIcon: BuildGraphic,
  title: "Build High Converting Sequences with Ease",
  description: <DescriptionText />,
  graphic: <HighConvertingSequencesImage />,
  // imageLeft: false,
  textLong: false,
  tint: "#F8F2F7",
  benefits: [
    {
      benefitTitle: "Easy-to-Use Builder",
      benefitDescription:
        "Create and display your Steps logically in order using our visual Builder.",
    },
    {
      benefitTitle: "Take Action",
      benefitDescription:
        "Update Contacts, Send Notifications, Transfer to other Sequences and more.",
    },
    {
      benefitTitle: "Flexible Start Options",
      benefitDescription:
        "Start your Sequence multiple ways - manually, on opt-in or Conditional based on a Contact’s properties.",
    },
    {
      benefitTitle: "Automatic Suppression",
      benefitDescription:
        "Stop your Sequence automatically when a Contact’s properties change.  Want to stop sending new Offers once a Lead becomes a Customer.  No problem!",
    },
  ],
}

export default highConvertingSequencesData
